// Regra ÚNICA de acesso a menu/permissão de perfil. Todo consumidor deve passar
// por aqui — antes existiam quatro cópias inline desta lógica (menu lateral,
// filtros de ticket, filtro de follow-up, Kanban) e elas divergiam justamente no
// caso de lista vazia, umas liberando e outras negando.
//
// Duas garantias, nesta ordem:
//
// 1. Admin é liberado SEM consultar a lista. Assim toda chave de menu criada no
//    futuro já nasce permitida para o administrador, sem depender de ninguém
//    lembrar de acrescentá-la ao `allMenus` do backend.
// 2. Não-admin só recebe o que o perfil marcou explicitamente. Lista vazia nega
//    tudo (fail-closed): é o caso de perfil sem menus e o do usuário órfão de um
//    perfil renomeado/excluído — nas duas situações o certo é travar, não abrir.
//    Chave nova, portanto, nasce negada para não-admin, que é o comportamento
//    desejado: quem quiser liberá-la marca na tela de Perfis.
export const canShowMenu = (user, menus, menuKey) => {
  if (String(user?.profile || "").toLowerCase() === "admin") return true;
  if (!Array.isArray(menus) || menus.length === 0) return false;
  return menus.includes(menuKey);
};

// "Pode gerenciar conexoes?" decide entre o texto que manda avisar o admin e o
// que aponta para a pagina de Conexoes, e tambem o escopo do aviso.
export const canManageConnections = (user, menus) =>
  canShowMenu(user, menus, "conexoes");

// Permissão de perfil "Atendimentos - Ver histórico completo do contato": no
// modo de histórico "Por ticket", quem a tem vê todas as mensagens do contato.
// Quem decide os dados é o backend (MessageController); aqui é só para a tela
// tratar o histórico como "por contato" (selo de conexão, seletor da aba Contatos).
export const FULL_HISTORY_MENU_KEY = "tickets_historico_completo";

export const canSeeFullHistory = (user, menus) =>
  canShowMenu(user, menus, FULL_HISTORY_MENU_KEY);

// Permissão de perfil "Atendimentos - Fazer e atender ligações" (WhatsApp Calling).
export const CALLS_MENU_KEY = "tickets_ligar";
